import { render, staticRenderFns } from "./loginQuestion.vue?vue&type=template&id=27778bd4&scoped=true&"
import script from "./loginQuestion.vue?vue&type=script&lang=js&"
export * from "./loginQuestion.vue?vue&type=script&lang=js&"
import style0 from "./loginQuestion.vue?vue&type=style&index=0&id=27778bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27778bd4",
  null
  
)

export default component.exports